import { render, staticRenderFns } from "./textual-menu.vue?vue&type=template&id=007d080b&scoped=true"
import script from "./textual-menu.vue?vue&type=script&lang=ts"
export * from "./textual-menu.vue?vue&type=script&lang=ts"
import style0 from "./textual-menu.vue?vue&type=style&index=0&id=007d080b&prod&lang=css"
import style1 from "./textual-menu.vue?vue&type=style&index=1&id=007d080b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007d080b",
  null
  
)

export default component.exports